import React from "react";
import {
  Grid,
  TextField,
  FormControlLabel,
  Switch,
  Typography,
  Box,
  useTheme,
} from "@mui/material";

interface Props {
  config: any;
  onChange: (field: string, value: any) => void;
}

const ArchivalOptionsForm: React.FC<Props> = ({ config, onChange }) => {
  const theme = useTheme();
  const red = "#C62828";

  return (
    <Box>
      <Typography
        variant="subtitle1"
        sx={{ fontWeight: 600, mb: 1, color: red }}
      >
        Archival Options
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <FormControlLabel
            control={
              <Switch
                checked={config.archival_enabled || false}
                onChange={(e) => onChange("archival_enabled", e.target.checked)}
              />
            }
            label="Archival Enabled"
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Archival Days"
            type="number"
            value={config.archival_days || ""}
            onChange={(e) => onChange("archival_days", e.target.value)}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default ArchivalOptionsForm;
